import './ResponseRateLegend.css';

interface LegendItem {
  color: string;
  label: string;
  range: string;
}

const LEGEND_ITEMS: LegendItem[] = [
  { color: '#ee7f5c', label: 'No responses', range: '0%' },
  { color: '#efa3a5', label: 'Far from target', range: '1-24%' },
  { color: '#f9d9bb', label: 'Close to target', range: '25-74%' },
  { color: '#53c55f', label: 'Meets target', range: '75%+' },
];

const ResponseRateLegend = () => (
  <div className="response-rate-legend">
    {LEGEND_ITEMS.map(({ color, label, range }) => (
      <div key={label} className="response-rate-legend-item">
        <div className="response-rate-legend-circle" style={{ backgroundColor: color }} />
        <span>
          {label} - {range}
        </span>
      </div>
    ))}
  </div>
);

export default ResponseRateLegend;
